import React from "react";
import { Link } from "react-router-dom";
import "./LEDBusiness.css";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouse } from "@fortawesome/free-solid-svg-icons";

const LEDBusiness = () => {
  return (
    <div className="about">
      <Header />

      <div className="container">
        <img src="/assets/images/sub/sub01.jpg" alt="" className="mainImg" />
        <div className="innerTop">
          <div className="subTitle">
            <h2>LED 사업</h2>
            <h1>
              일상을 환하게,
              <br />
              공간을 특별하게
            </h1>
          </div>
          <div className="menuNav">
            <FontAwesomeIcon icon={faHouse} className="faHouse" />
            <span>/</span>
            <h2>LED 사업</h2>
            <span>/</span>
            <h2>LED 사업</h2>
          </div>
        </div>
      </div>
      <div className="menuBar">
        <Link to="/led" className="ledMenu">
          <h2>LED 사업</h2>
        </Link>
      </div>

      <div className="contentInner">
        <h1>빛으로 완성되는 공간, 새로운 차원의 경관</h1>
        <h2 className="ledh2">
          저희 한국미광에서는 체계적인 디자인 설계, 고품질 제품 생산, 철저한
          사후 서비스를 포함한 여러 분야의 우수한 자격을 갖춘 인재들과 함께
          나아갑니다.
        </h2>
        <div className="ledTitle">
          <h2>LED 사업</h2>
          <strong>LED BUSINESS</strong>
        </div>
        <div className="ledInner contentLeft">
          <img src="/assets/images/sub/led01.jpg" alt="" />
          <div>
            <h3>
              특수 건출물 경관조명
              <br />
              보수, 관리, 전문 시공업
            </h3>
            <li>삼천포대교 공원 라인바 조명공사</li>
            <li>순천 동천변 저류지 야간경관 조성공사</li>
            <li>밀양 3대 신비 조형물 라인바 조명공사</li>
            <li>밀양 예림교 경관조명 설치공사</li>
          </div>
        </div>
        <div className="ledInner contentRight">
          <div>
            <h3>
              다양한 건축물의 LED경관조명
              <br />및 복합 시공 전문
            </h3>
            <li>남해 대교 관광자원화사업 경관조명공사</li>
            <li>사천 실안낙조와 어우러진 포토존 경관조명 설치공사</li>
            <li>충북 보강천 인도교 설치사업</li>
          </div>
          <img src="/assets/images/sub/led02.jpg" alt="" />
        </div>
        <div className="ledInner contentLeft">
          <img src="/assets/images/sub/led03.jpg" alt="" />
          <div>
            <h3>
              경관조명 특수 디자인 제품 제작
              <br />및 검증 테스트
            </h3>
            <li>엘이디 라인바용 실링 마감 캡</li>
            <li>조명이 구비된 계단용 논슬립</li>
            <li>투광등</li>
            <li>조명기구 설치용 브라켓</li>
            <li>빛 투과 길이 조절수단이 구비된 투광등</li>
            <li>난간 조명장치</li>
          </div>
        </div>
        <div className="ledInner contentRight">
          <div>
            <h3>
              전문성 높은 디자인, 설계
              <br />및 고효율 조명 보유
            </h3>
            <li>KNMG-SE50W50KA</li>
            <li>KNMG-SE60W50KA</li>
            <li>KNMG-SL100W50KA</li>
            <li>KNMG-SL120W50KA</li>
            <li>KNMG-SL120W50KA</li>
          </div>
          <img src="/assets/images/sub/led04.png" alt="" />
        </div>
      </div>
      <div className="solution">
        <h2>LED 토탈솔루션 진행 절차</h2>
        <div className="solutionStep">
          <div>
            <div className="imgWrapper">
              <div className="imgWrapper">
                <img src="/assets/icons/sub/led01.png" alt="" />
              </div>
            </div>
            <div>
              <span>STEP 01</span>
              <p>견적문의</p>
            </div>
            <p>1</p>
          </div>
          <div>
            <div className="imgWrapper">
              <img src="/assets/icons/sub/led02.png" alt="" />
            </div>
            <div>
              <span>STEP 02</span>
              <p>현장방문</p>
            </div>
            <p>2</p>
          </div>
          <div>
            <div className="imgWrapper">
              <img src="/assets/icons/sub/led03.png" alt="" />
            </div>
            <div>
              <span>STEP 03</span>
              <p>기본설계</p>
            </div>
            <p>3</p>
          </div>
          <div>
            <div className="imgWrapper">
              <img src="/assets/icons/sub/led04.png" alt="" />
            </div>
            <div>
              <span>STEP 04</span>
              <p>실시설계</p>
            </div>
            <p>4</p>
          </div>
          <div>
            <div className="imgWrapper">
              <img src="/assets/icons/sub/led05.png" alt="" />
            </div>
            <div>
              <span>STEP 05</span>
              <p>계약수립</p>
            </div>
            <p>5</p>
          </div>
          <div>
            <div className="imgWrapper">
              <img src="/assets/icons/sub/led06.png" alt="" />
            </div>
            <div>
              <span>STEP 06</span>
              <p>현장실사</p>
            </div>
            <p>6</p>
          </div>
          <div>
            <div className="imgWrapper">
              <img src="/assets/icons/sub/led07.png" alt="" />
            </div>
            <div>
              <span>STEP 07</span>
              <p>시공</p>
            </div>
            <p>7</p>
          </div>
          <div>
            <div className="imgWrapper">
              <img src="/assets/icons/sub/led08.png" alt="" />
            </div>
            <div>
              <span>STEP 08</span>
              <p>사후점검</p>
            </div>
            <p>8</p>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  );
};

export default LEDBusiness;
